import React, { Component } from 'react';
import { Col } from "antd";
import '../components-style.css';
import {FormattedMessage} from 'react-intl';


//Battery img
import battery_full from '../../Images/Battery/battery_full.png';
import battery_80 from '../../Images/Battery/battery_80.png';
import battery_50 from '../../Images/Battery/battery_50.png';
import battery_20 from '../../Images/Battery/battery_20.png';
import battery_6 from '../../Images/Battery/battery_6.png';

//Battery img for alerts
import battery_full_alert from '../../Images/Battery/battery_full_alert.png';
import battery_80_alert from '../../Images/Battery/battery_80_alert.png';
import battery_50_alert from '../../Images/Battery/battery_50_alert.png';
import battery_20_alert from '../../Images/Battery/battery_20_alert.png';
import battery_6_alert from '../../Images/Battery/battery_6_alert.png';

class BatteryDisplay extends Component {

    //Function to get battery icon
    getBatteryIcon = (batteryLevel, alert) =>{

        //if battery level is (almost) full
        if(batteryLevel > 80){
            if(alert){
                return(
                    <img
                        src={battery_full_alert}
                        style={{ height: "auto", maxHeight: "30px", width: "auto"}}
                        alt="battery-full-alert"  
                    />
                );   
            }
            else{
                return(
                    <img
                        src={battery_full}
                        style={{ height: "auto", maxHeight: "30px", width: "auto"}}
                        alt="battery-full"  
                    />
                );
            }
        }

        //If battery level is (pretty) high (between 50 and 80 %)
        else if((batteryLevel <= 80)&&(batteryLevel > 50)){
            if(alert){
                return(
                    <img
                        src={battery_80_alert}
                        style={{ height: "auto", maxHeight: "30px", width: "auto"}}
                        alt="battery-80-alert"  
                    />             
                );   
            }
            else{
                return(
                    <img
                        src={battery_80}
                        style={{ height: "auto", maxHeight: "30px", width: "auto"}}
                        alt="battery-80"  
                    />  
                );
            }
        }

        //If battery level is pretty low (between 20 and 50 %)
        else if((batteryLevel <= 50)&&(batteryLevel > 20)){
            if(alert){
                return(
                    <img
                        src={battery_50_alert}
                        style={{ height: "auto", maxHeight: "30px", width: "auto"}}
                        alt="battery-50-alert"  
                    />               
                );   
            }
            else{
                return(
                    <img
                        src={battery_50}
                        style={{ height: "auto", maxHeight: "30px", width: "auto"}}
                        alt="battery-50"  
                    />   
                );
            }
        }

        //If battery level is low (between 6 and 20 %)
        else if((batteryLevel <= 20)&&(batteryLevel > 6)){
            if(alert){
                return(
                    <img
                        src={battery_20_alert}
                        style={{ height: "auto", maxHeight: "30px", width: "auto"}}
                        alt="battery-20-alert"  
                    />                
                );   
            }
            else{
                return(
                    <img
                        src={battery_20}
                        style={{ height: "auto", maxHeight: "30px", width: "auto"}}
                        alt="battery-20"  
                    />   
                );
            }
        }

        //If battery level is very low (below 6 %)
        else if(batteryLevel <= 6){
            if(alert){
                return(
                    <img
                        src={battery_6_alert}
                        style={{ height: "auto", maxHeight: "30px", width: "auto"}}
                        alt="battery-6-alert"  
                    />               
                );   
            }
            else{
                return(
                    <img
                        src={battery_6}
                        style={{ height: "auto", maxHeight: "30px", width: "auto"}}
                        alt="battery-6"  
                    />      
                );
            }
        }

        //If battery level is not defined or not retrieved, display "NC"
        else{
            return(null);   
        }
    }

    render(){

        return(
            <Col id="col-battery-level">
                {(this.props.alert) ?
                    <Col id="col-icon-alert">
                        {this.getBatteryIcon(this.props.batteryLevel, this.props.alert)}
                    </Col>
                    :
                    <Col id="col-icon">
                        {this.getBatteryIcon(this.props.batteryLevel, this.props.alert)}
                    </Col>
                }
            </Col>
        )
   	}
}
export default (BatteryDisplay);